/* eslint-disable consistent-return */
/* eslint-disable array-callback-return */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable object-shorthand */
/* eslint-disable no-unneeded-ternary */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/forbid-prop-types */
import React, { useCallback, useEffect, useState } from 'react';
import AsyncSelect from 'react-select/async';
import PropTypes from 'prop-types';
import { isMobileWidth } from '../../helper-utils/appUtils';
import AppTextInput from '../app-text-input/AppTextInput';
import AppSidebar from '../app-sidebar/AppSidebar';
import { debounce } from '../../../api/apiUtils';
import { getAirportsApi } from '../../../api/flightApi';
import { getCitiesApiV2 } from '../../../api/hotelApi';
import './AppAsyncSelect.scss';
import { getCitiesApi } from '../../../api/busApi';

function AppAsyncSelect({
  name,
  selectedValue,
  loadOptionsFn,
  onSelect,
  isClearable,
  placeholder,
  className,
  selectWidth,
  menuWidth,
  label,
  height,
  bgColor,
  padding,
  color,
  labelClassName,
  menuStartFromRight,
  defaultOptions,
  selectedTab,
  ...rest
}) {
  const [showMobilePopup, setShowMobilePopup] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [cityList, setCityList] = useState(undefined);
  const [popularList, setPopularList] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false);
  // const handleOnFocus = () => {
  //   const range = document.createRange();
  //   range.selectNode(
  //     document.getElementsByClassName('react-select__single-value')[0],
  //   );
  //   window.getSelection().removeAllRanges();
  //   window.getSelection().addRange(range);
  //   const input = document.querySelector('react-select__input');
  //   if (input) {
  //     input.setAttribute('aria-expanded', 'true');
  //   }
  // };
  useEffect(() => {
    setPopularList(defaultOptions);
  }, [defaultOptions]);
  const getLabel = (location) => {
    return (
      <div className="d-flex fs-16 aas-mobile__selected-location">
        {location}
      </div>
    );
  };
  const handleGetCities = async (query) => {
    setIsLoading(true);
    if (selectedTab === 'flight') {
      if (query.length > 2) {
        let airports = [];
        const response = await getAirportsApi(query);
        airports = response.map((airportNode) => ({
          value: airportNode.AirportCode,
          ...airportNode,
        }));
        setCityList(airports);
      }
    } else if (selectedTab === 'hotel' || selectedTab === 'cabs') {
      if (query.length > 2) {
        setIsLoading(true);
        let cities = [];
        const response = await getCitiesApiV2(query);
        cities = response.predictions
          .map((cityNode) => {
            if (cityNode.place_id !== undefined) {
              return {
                value: cityNode.description.split(',')[0],
                label: cityNode.description.split(',')[0],
                placeId: cityNode.place_id,
                country: cityNode.description
                  .split(',')
                  [cityNode.description.split(',').length - 1].trim(),
                destinationType: cityNode.types,
              };
            }
          })
          .filter((city) => city !== undefined); // Filter out any undefined values in case a cityNode doesn't meet the condition
        setCityList(cities);
      }
    } else if (selectedTab === 'bus') {
      if (query.length > 2) {
        setIsLoading(true);
        let busCities = [];
        const response = await getCitiesApi(query);
        busCities = response.map((cityNode) => ({
          label: getLabel(cityNode.locationname),
          value: cityNode.locationcode,
          ...cityNode,
        }));
        setCityList(busCities);
      }
    }
    setIsLoading(false);
  };

  const debouncedSearch = useCallback(
    debounce((query) => {
      handleGetCities(query);
    }, 500),
    [],
  );

  const handleInputChange = (value) => {
    setSearchQuery(value);
    debouncedSearch(value);
  };

  const handleOnChangeInMobile = (value) => {
    onSelect(value, name);
    setCityList(undefined);
    setShowMobilePopup(false);
  };
  return !isMobileWidth() ? (
    <div className="position-relative w-100">
      <label
        htmlFor="asyncSelect"
        className={`position-absolute async-select-label fs-12 ${labelClassName}`}
      >
        {label}
      </label>
      <AsyncSelect
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          menu: (base) => ({
            ...base,
            zIndex: 9999,
            width: menuWidth,
            right: menuStartFromRight ? '0' : '',
          }),
          menuList: (base) => ({
            ...base,
            maxHeight: '200px',
            width: menuWidth,
            backgroundColor: '#fff',
          }),
          control: (base) => ({
            ...base,
            width: selectWidth,
            height: height ? height : '84px',
            borderRadius: '5px',
            backgroundColor: bgColor,
            border: 'none',
          }),
          valueContainer: (base) => ({
            ...base,
            cursor: 'pointer',
            padding: padding,
            borderRadius: '5px',
            backgroundColor: bgColor,
            height: height ? height : '84px',
            border: height ? 'none' : '1px solid #E2E2E2',
          }),
          input: (base) => ({
            ...base,
            height: height ? '48px' : '72px',
            color: color,
          }),
          indicatorsContainer: (base) => ({
            ...base,
            display: 'none',
          }),
          singleValue: (base) => ({
            ...base,
            color: color,
          }),
        }}
        placeholder={placeholder}
        classNamePrefix="react-select"
        className={`app-select ${className}`}
        cacheOptions={false}
        isClearable={isClearable}
        value={selectedValue}
        loadOptions={loadOptionsFn}
        defaultOptions={defaultOptions}
        onChange={(value) => onSelect(value, name)}
        // onFocus={handleOnFocus}
        {...rest}
      />
    </div>
  ) : (
    <>
      {selectedTab === 'flight' && (
        <>
          <div
            onClick={() => setShowMobilePopup(true)}
            className="app-mobile-datepicker-style"
          >
            <label style={{ fontSize: '10px', marginTop: '-4px' }}>
              {label}
            </label>
            <div className="d-flex flex-column">
              <span style={{ fontSize: '14px', fontWeight: '600' }}>
                {selectedValue?.AirportLocation?.split(',')[0]} -{' '}
                {selectedValue?.value}
              </span>
            </div>
          </div>

          {showMobilePopup && (
            <AppSidebar
              sidebarTitle={label}
              onHideSidebar={() => setShowMobilePopup(false)}
              className="app-mobile-datepicker-modal"
            >
              <div className="app-async-select-mobile">
                <div className="aas-mobile__search-city">
                  <div className="aas-mobile__search-city-search-bar m-2">
                    <AppTextInput
                      className="mt-0 br-0"
                      placeholderText="Search Airport"
                      value={searchQuery}
                      autoFocus
                      onChange={(e) => handleInputChange(e.target.value)}
                    />
                  </div>
                </div>
                {isLoading && (
                  <div className="aas-mobile__loading_text">Loading ...</div>
                )}

                {isLoading === false &&
                  cityList === undefined &&
                  popularList &&
                  popularList.length > 0 && (
                    <>
                      <h6 className="bg-body-secondary mt-2 p-2">
                        Popular Airports
                      </h6>
                      {popularList.map((city) => (
                        <div
                          key={city.AirportName}
                          className="aas-mobile__search-city_city-names mx-3 p-15"
                          onClick={() => {
                            handleOnChangeInMobile(city);
                          }}
                        >
                          <div className="aas-mobile__destination_icon">
                            <div className="aas-mobile__search-city_city-name">
                              <span>{city.AirportLocation}</span>
                              <span className="aas-mobile__search-city_airport-name">
                                {city.AirportName}
                              </span>
                            </div>
                          </div>
                          <div className="d-flex flex-column align-items-end">
                            <span>
                              <img
                                src={`https://cdn.jsdelivr.net/gh/lipis/flag-icons/flags/4x3/${city.CountryCode.toLowerCase()}.svg`}
                                width="25px"
                                height="15px"
                              />
                            </span>
                            <span className="aas-mobile__search-city_airport-code">
                              {city.AirportCode}
                            </span>
                          </div>
                        </div>
                      ))}
                    </>
                  )}

                {!isLoading &&
                  cityList &&
                  cityList.length > 0 &&
                  cityList.map((city) => (
                    <div
                      key={city.AirportName}
                      className="aas-mobile__search-city_city-names p-15 d-flex justify-content-between"
                      onClick={() => {
                        handleOnChangeInMobile(city);
                      }}
                    >
                      <div className="aas-mobile__destination_icon">
                        <div className="aas-mobile__search-city_city-name">
                          <span>{city.AirportLocation}</span>{' '}
                          <span className="aas-mobile__search-city_airport-name">
                            {city.AirportName}
                          </span>
                        </div>
                      </div>
                      <div className="d-flex flex-column align-items-end">
                        <span>
                          <img
                            src={`https://cdn.jsdelivr.net/gh/lipis/flag-icons/flags/4x3/${city.CountryCode.toLowerCase()}.svg`}
                            width="25px"
                            height="15px"
                          />
                        </span>
                        <span className="aas-mobile__search-city_airport-code">
                          {city.AirportCode}
                        </span>
                      </div>
                    </div>
                  ))}
                {cityList && cityList.length === 0 && !isLoading && (
                  <div className="d-flex justify-content-center fw-500">
                    No results found.
                  </div>
                )}
              </div>
            </AppSidebar>
          )}
        </>
      )}
      {(selectedTab === 'hotel' || selectedTab === 'cabs') && (
        <>
          <div
            onClick={() => setShowMobilePopup(true)}
            className="app-mobile-datepicker-style"
          >
            <label style={{ fontSize: '10px', marginTop: '-4px' }}>
              {label}
            </label>
            {selectedValue ? (
              <div className="fw-600 hl-mobile-view">
                {selectedValue?.label}
              </div>
            ) : (
              <div className="fs-14 grey-color">Select City</div>
            )}
          </div>

          {showMobilePopup && (
            <AppSidebar
              sidebarTitle="Select City"
              onHideSidebar={() => setShowMobilePopup(false)}
              className="app-mobile-datepicker-modal"
            >
              <div className="app-async-select-mobile mx-2">
                <div className="aas-mobile__search-city">
                  <div className="aas-mobile__search-city-search-bar m-2">
                    <AppTextInput
                      className="mt-0 br-0"
                      placeholderText="Search City"
                      value={searchQuery}
                      autoFocus
                      onChange={(e) => handleInputChange(e.target.value)}
                    />
                  </div>
                </div>
                {isLoading && (
                  <div className="aas-mobile__loading_text">Loading ...</div>
                )}

                {!isLoading &&
                  cityList &&
                  cityList.length > 0 &&
                  cityList.map((city) => (
                    <div
                      key={city.AirportName}
                      className="aas-mobile__search-city_city-names p-15"
                      onClick={() => {
                        handleOnChangeInMobile(city);
                      }}
                    >
                      <div className="aas-mobile__destination_icon">
                        <div className="aas-mobile__search-city_city-name">
                          <span>{city.value}</span>
                          <span className="fs-10 grey-color d-flex">
                            {city.country}
                          </span>
                        </div>
                      </div>
                    </div>
                  ))}
                {cityList && cityList.length === 0 && !isLoading && (
                  <div className="d-flex justify-content-center fw-500">
                    No results found.
                  </div>
                )}
              </div>
            </AppSidebar>
          )}
        </>
      )}
      {selectedTab === 'bus' && (
        <>
          <div
            onClick={() => setShowMobilePopup(true)}
            className="app-mobile-datepicker-style"
          >
            <label style={{ fontSize: '10px', marginTop: '-4px' }}>
              {label}
            </label>
            <div className="fs-16  aas-mobile__selected-location">
              {selectedValue?.label}
            </div>
          </div>

          {showMobilePopup && (
            <AppSidebar
              sidebarTitle={label}
              onHideSidebar={() => setShowMobilePopup(false)}
              animatedClass="slide-from-right-animation"
              className="app-mobile-datepicker-modal"
            >
              <div className="app-async-select-mobile">
                <div className="aas-mobile__search-city">
                  <div className="aas-mobile__search-city-search-bar m-2">
                    <AppTextInput
                      className="mt-0 br-0"
                      placeholderText="Search City"
                      value={searchQuery}
                      autoFocus
                      onChange={(e) => handleInputChange(e.target.value)}
                    />
                  </div>
                </div>
                {isLoading && (
                  <div className="aas-mobile__loading_text">Loading ...</div>
                )}
                {!isLoading &&
                  cityList &&
                  cityList.length > 0 &&
                  cityList.map((city) => (
                    <div
                      key={city.AirportName}
                      className="aas-mobile__search-city_city-names p-15"
                      onClick={() => {
                        handleOnChangeInMobile(city);
                      }}
                    >
                      <div className="aas-mobile__search-city_city-name p-1">
                        {city.locationname}
                      </div>
                    </div>
                  ))}
                {cityList && cityList.length === 0 && !isLoading && (
                  <div className="d-flex justify-content-center fw-500">
                    No results found.
                  </div>
                )}
              </div>
            </AppSidebar>
          )}
        </>
      )}
    </>
  );
}

AppAsyncSelect.defaultProps = {
  isClearable: true,
  selectedValue: null,
  className: '',
  selectWidth: '',
  menuWidth: '100%',
  label: '',
  bgColor: '#fff',
  color: '#000',
  padding: '6px 20px',
  labelClassName: '',
  menuStartFromRight: false,
  defaultOptions: '',
  selectedTab: '',
};

AppAsyncSelect.propTypes = {
  isClearable: PropTypes.bool,
  className: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  selectedValue: PropTypes.any,
  loadOptionsFn: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  selectWidth: PropTypes.string,
  label: PropTypes.string,
  height: PropTypes.string.isRequired,
  menuWidth: PropTypes.string,
  bgColor: PropTypes.any,
  padding: PropTypes.any,
  color: PropTypes.any,
  labelClassName: PropTypes.any,
  menuStartFromRight: PropTypes.bool,
  defaultOptions: PropTypes.any,
  selectedTab: PropTypes.any,
};

export default AppAsyncSelect;
